import React from 'react';
import SvgIcon from './SvgIcon';
const UserFull = props => {
    return (
        <SvgIcon viewBox="0 0 24 24" fill="none" {...props}>
            <path
                d="M23 23.5v-3.106a1.98 1.98 0 00-.77-1.58C20.9 17.8 17.73 16 12 16s-8.895 1.8-10.23 2.814a1.98 1.98 0 00-.77 1.58V23.5M9 8h1M15 8h-1M18 6.5a6 6 0 10-12 0v2a6 6 0 1012 0v-2z"
                stroke="currentColor"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M12 10.5a3.5 3.5 0 00-3.45 2.909 6 6 0 006.9 0A3.5 3.5 0 0012 10.5v0zM11 12.5h2M16.481 16.414a4.5 4.5 0 01-8.962 0M19 17.109V23.5M5 17.109V23.5M9.5 4.05A3.49 3.49 0 0112 3"
                stroke="currentColor"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </SvgIcon>
    );
};

UserFull.displayName = 'UserFullIcon';

export default UserFull;
